export default "__VITE_ASSET__DlwIgJhq__"